import { render, staticRenderFns } from "./CardGoToNegotiationAction.vue?vue&type=template&id=3bafabfd"
import script from "./CardGoToNegotiationAction.vue?vue&type=script&lang=js"
export * from "./CardGoToNegotiationAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports